import { IResponse } from "models";

export enum ActionType {
  DELETE_STRESS_CHECK = "action/DELETE_STRESS_CHECK",
  DELETE_STRESS_CHECK_SUCCESS = "action/DELETE_STRESS_CHECK_SUCCESS",
  DELETE_STRESS_CHECK_ERROR = "action/DELETE_STRESS_CHECK_ERROR",
  RESET_DELETE_STRESS_CHECK = "action/RESET_DELETE_STRESS_CHECK",
}

export interface Action<T> {
  type: ActionType;
  payload: T;
}

export interface IDeleteStressCheckResponse extends IResponse {
  result: any;
}

export interface DeleteStressCheckData {
  id?: number;
}
